import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import StorageService from '../../common/helpers/storageService/storage-service';
import { localStorage } from '../../../types/types';
//
const token =
  process.env?.REACT_APP_OAUTH2 === 'false' ? StorageService.get(localStorage.token) : false;

export interface AuthorizationState {
  isAuth: boolean;
  isLoading: boolean;
}

const initialState: AuthorizationState = {
  isAuth: token,
  isLoading: false,
};

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    setIsAuth(state, action: PayloadAction<boolean>) {
      state.isAuth = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export default authorizationSlice.reducer;
